import { render, staticRenderFns } from "./base-icon-svg.vue?vue&type=template&id=403091da&"
import script from "./base-icon-svg.vue?vue&type=script&lang=js&"
export * from "./base-icon-svg.vue?vue&type=script&lang=js&"
import style0 from "./base-icon-svg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports